/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GlobalFilterExclusionInput } from './GlobalFilterExclusionInput';
import {
    GlobalFilterExclusionInputFromJSON,
    GlobalFilterExclusionInputFromJSONTyped,
    GlobalFilterExclusionInputToJSON,
    GlobalFilterExclusionInputToJSONTyped,
} from './GlobalFilterExclusionInput';
import type { SocialPolicy } from './SocialPolicy';
import {
    SocialPolicyFromJSON,
    SocialPolicyFromJSONTyped,
    SocialPolicyToJSON,
    SocialPolicyToJSONTyped,
} from './SocialPolicy';
import type { QuestReset } from './QuestReset';
import {
    QuestResetFromJSON,
    QuestResetFromJSONTyped,
    QuestResetToJSON,
    QuestResetToJSONTyped,
} from './QuestReset';
import type { EventValidator } from './EventValidator';
import {
    EventValidatorFromJSON,
    EventValidatorFromJSONTyped,
    EventValidatorToJSON,
    EventValidatorToJSONTyped,
} from './EventValidator';
import type { RewardConfigResponse } from './RewardConfigResponse';
import {
    RewardConfigResponseFromJSON,
    RewardConfigResponseFromJSONTyped,
    RewardConfigResponseToJSON,
    RewardConfigResponseToJSONTyped,
} from './RewardConfigResponse';
import type { LogicModuleType } from './LogicModuleType';
import {
    LogicModuleTypeFromJSON,
    LogicModuleTypeFromJSONTyped,
    LogicModuleTypeToJSON,
    LogicModuleTypeToJSONTyped,
} from './LogicModuleType';
import type { MilestoneSubtype } from './MilestoneSubtype';
import {
    MilestoneSubtypeFromJSON,
    MilestoneSubtypeFromJSONTyped,
    MilestoneSubtypeToJSON,
    MilestoneSubtypeToJSONTyped,
} from './MilestoneSubtype';
import type { RewardGrant } from './RewardGrant';
import {
    RewardGrantFromJSON,
    RewardGrantFromJSONTyped,
    RewardGrantToJSON,
    RewardGrantToJSONTyped,
} from './RewardGrant';
import type { MilestoneCheckpoint } from './MilestoneCheckpoint';
import {
    MilestoneCheckpointFromJSON,
    MilestoneCheckpointFromJSONTyped,
    MilestoneCheckpointToJSON,
    MilestoneCheckpointToJSONTyped,
} from './MilestoneCheckpoint';
import type { DataSource } from './DataSource';
import {
    DataSourceFromJSON,
    DataSourceFromJSONTyped,
    DataSourceToJSON,
    DataSourceToJSONTyped,
} from './DataSource';

/**
 * Composition note: exactly ONE bare `$ref` in the allOf, per the repo
 * convention in `.claude/CLAUDE.md`. This carried `$ref: Base` AND
 * `$ref: LogicModule`; the LogicModule ref is kept because it is much
 * the larger of the two, and `Base`'s single `id` is inlined below.
 * 
 * Scope of the claim, deliberately narrow: the convention says a second
 * bare ref is silently dropped, but the checked-in client generated at
 * openapi-generator 4.3.0 (`client/client/models/QuestConfigMilestone.ts`)
 * carries `id` from Base AND `logicType`/`targetAmount` from LogicModule
 * — so nothing was being lost at that version. This rewrite conforms to
 * the convention; it is not evidence of a bug it fixed.
 * 
 * `id` matters here specifically: the admin quest tree keys milestone
 * rows on it, and both quest-progression endpoints go out of their way
 * to stamp it from Mongo's `_id` because raw subdocuments do not carry
 * one.
 * 
 * @export
 * @interface QuestConfigMilestone
 */
export interface QuestConfigMilestone {
    /**
     * 
     * @type {LogicModuleType}
     * @memberof QuestConfigMilestone
     */
    logicType: LogicModuleType;
    /**
     * 
     * @type {number}
     * @memberof QuestConfigMilestone
     */
    targetAmount: number;
    /**
     * 
     * @type {number}
     * @memberof QuestConfigMilestone
     */
    sessionAmount?: number;
    /**
     * 
     * @type {QuestReset}
     * @memberof QuestConfigMilestone
     */
    sessionCadence?: QuestReset;
    /**
     * 
     * @type {EventValidator}
     * @memberof QuestConfigMilestone
     */
    triggerEvent: EventValidator;
    /**
     * 
     * @type {EventValidator}
     * @memberof QuestConfigMilestone
     */
    resetEvent?: EventValidator;
    /**
     * 
     * @type {EventValidator}
     * @memberof QuestConfigMilestone
     */
    finishEvent?: EventValidator;
    /**
     * 
     * @type {Array<DataSource>}
     * @memberof QuestConfigMilestone
     */
    sources?: Array<DataSource>;
    /**
     * 
     * @type {string}
     * @memberof QuestConfigMilestone
     */
    id: string;
    /**
     * The EarnConfig this milestone runs. When present it owns the action definition and the fields alongside it are legacy copies.
     * @type {string}
     * @memberof QuestConfigMilestone
     */
    earnConfigId?: string;
    /**
     * 
     * @type {SocialPolicy}
     * @memberof QuestConfigMilestone
     */
    socialPolicy?: SocialPolicy;
    /**
     * 
     * @type {Array<string>}
     * @memberof QuestConfigMilestone
     */
    rewardConfigIds?: Array<string>;
    /**
     * Per-reward auto-claim settings. Key is rewardConfigId, value is true for auto-reward, false for manual claim.
     * @type {{ [key: string]: boolean; }}
     * @memberof QuestConfigMilestone
     */
    rewardAutoSettings?: { [key: string]: boolean; };
    /**
     * 
     * @type {Array<RewardConfigResponse>}
     * @memberof QuestConfigMilestone
     */
    rewardConfigs?: Array<RewardConfigResponse>;
    /**
     * Catalog-item grants (reward-catalog Option B) — additive alongside rewardConfigIds during the migration.
     * @type {Array<RewardGrant>}
     * @memberof QuestConfigMilestone
     */
    rewardGrants?: Array<RewardGrant>;
    /**
     * 
     * @type {string}
     * @memberof QuestConfigMilestone
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestConfigMilestone
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestConfigMilestone
     */
    gameId?: string;
    /**
     * 
     * @type {number}
     * @memberof QuestConfigMilestone
     */
    progressionOrder?: number;
    /**
     * 
     * @type {number}
     * @memberof QuestConfigMilestone
     */
    displayDivider?: number;
    /**
     * How often auto-rewards are distributed (e.g., 1 = per event for leaderboards). Works with rewardAutoSettings.
     * @type {number}
     * @memberof QuestConfigMilestone
     */
    rewardPer?: number;
    /**
     * Optional progression checkpoints with manual claim rewards
     * @type {Array<MilestoneCheckpoint>}
     * @memberof QuestConfigMilestone
     */
    checkpoints?: Array<MilestoneCheckpoint>;
    /**
     * 
     * @type {string}
     * @memberof QuestConfigMilestone
     */
    url?: string;
    /**
     * 
     * @type {MilestoneSubtype}
     * @memberof QuestConfigMilestone
     */
    subtype?: MilestoneSubtype;
    /**
     * Controls rendering order on frontend (lower = higher priority)
     * @type {number}
     * @memberof QuestConfigMilestone
     */
    displayPriority?: number;
    /**
     * Asset ID for example photo (PHOTO subtype only)
     * @type {string}
     * @memberof QuestConfigMilestone
     */
    photoExampleAssetId?: string;
    /**
     * Instructions for photo capture (PHOTO subtype only)
     * @type {string}
     * @memberof QuestConfigMilestone
     */
    photoInstructions?: string;
    /**
     * Instructions for code entry (CODE_ENTRY subtype only)
     * @type {string}
     * @memberof QuestConfigMilestone
     */
    codeInstructions?: string;
    /**
     * Instructions for QR scan (QR_SCAN subtype only)
     * @type {string}
     * @memberof QuestConfigMilestone
     */
    scanInstructions?: string;
    /**
     * Regex pattern for valid QR codes (QR_SCAN subtype only)
     * @type {string}
     * @memberof QuestConfigMilestone
     */
    validQrPattern?: string;
    /**
     * IDs of EventPipelineFilter documents applied to this milestone's events. Layered on top of the game-wide global filter; blocks when any assigned filter votes BLOCK (conditions AND-compose within each filter; exclude conditions block on match, include conditions block on non-match).
     * @type {Array<string>}
     * @memberof QuestConfigMilestone
     */
    appliedFilterIds?: Array<string>;
    /**
     * Break-glass per-entity exclusions of GLOBAL filters for this milestone (PRODUCT_PLAN D2(b)). Client supplies filterId/reason/expiresAt only — excludedBy/excludedAt are stamped server-side by validateExcludedGlobalFilters, same as every other carrier. Evaluated as set membership against the blocking-filter ids stamped on the fan-out message; expiry is enforced at read.
     * @type {Array<GlobalFilterExclusionInput>}
     * @memberof QuestConfigMilestone
     */
    excludedGlobalFilters?: Array<GlobalFilterExclusionInput>;
    /**
     * Rule 4 opt-out. When true this milestone still scores events whose match context is missing (the pre-Rule-4 behavior). Default false — a milestone that declares what counts should not score events that cannot prove they qualify.
     * @type {boolean}
     * @memberof QuestConfigMilestone
     */
    failOpenOnMissingContext?: boolean;
    /**
     * react-icons key for the step's tile on the journey map (e.g. FaDownload, FaGamepad, FaBullseye). Authored in the Journey Editor's steps list.
     * @type {string}
     * @memberof QuestConfigMilestone
     */
    icon?: string;
}



/**
 * Check if a given object implements the QuestConfigMilestone interface.
 */
export function instanceOfQuestConfigMilestone(value: object): value is QuestConfigMilestone {
    if (!('logicType' in value) || value['logicType'] === undefined) return false;
    if (!('targetAmount' in value) || value['targetAmount'] === undefined) return false;
    if (!('triggerEvent' in value) || value['triggerEvent'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function QuestConfigMilestoneFromJSON(json: any): QuestConfigMilestone {
    return QuestConfigMilestoneFromJSONTyped(json, false);
}

export function QuestConfigMilestoneFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuestConfigMilestone {
    if (json == null) {
        return json;
    }
    return {
        
        'logicType': LogicModuleTypeFromJSON(json['logicType']),
        'targetAmount': json['targetAmount'],
        'sessionAmount': json['sessionAmount'] == null ? undefined : json['sessionAmount'],
        'sessionCadence': json['sessionCadence'] == null ? undefined : QuestResetFromJSON(json['sessionCadence']),
        'triggerEvent': EventValidatorFromJSON(json['triggerEvent']),
        'resetEvent': json['resetEvent'] == null ? undefined : EventValidatorFromJSON(json['resetEvent']),
        'finishEvent': json['finishEvent'] == null ? undefined : EventValidatorFromJSON(json['finishEvent']),
        'sources': json['sources'] == null ? undefined : ((json['sources'] as Array<any>).map(DataSourceFromJSON)),
        'id': json['id'],
        'earnConfigId': json['earnConfigId'] == null ? undefined : json['earnConfigId'],
        'socialPolicy': json['socialPolicy'] == null ? undefined : SocialPolicyFromJSON(json['socialPolicy']),
        'rewardConfigIds': json['rewardConfigIds'] == null ? undefined : json['rewardConfigIds'],
        'rewardAutoSettings': json['rewardAutoSettings'] == null ? undefined : json['rewardAutoSettings'],
        'rewardConfigs': json['rewardConfigs'] == null ? undefined : ((json['rewardConfigs'] as Array<any>).map(RewardConfigResponseFromJSON)),
        'rewardGrants': json['rewardGrants'] == null ? undefined : ((json['rewardGrants'] as Array<any>).map(RewardGrantFromJSON)),
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'gameId': json['gameId'] == null ? undefined : json['gameId'],
        'progressionOrder': json['progressionOrder'] == null ? undefined : json['progressionOrder'],
        'displayDivider': json['displayDivider'] == null ? undefined : json['displayDivider'],
        'rewardPer': json['rewardPer'] == null ? undefined : json['rewardPer'],
        'checkpoints': json['checkpoints'] == null ? undefined : ((json['checkpoints'] as Array<any>).map(MilestoneCheckpointFromJSON)),
        'url': json['url'] == null ? undefined : json['url'],
        'subtype': json['subtype'] == null ? undefined : MilestoneSubtypeFromJSON(json['subtype']),
        'displayPriority': json['displayPriority'] == null ? undefined : json['displayPriority'],
        'photoExampleAssetId': json['photoExampleAssetId'] == null ? undefined : json['photoExampleAssetId'],
        'photoInstructions': json['photoInstructions'] == null ? undefined : json['photoInstructions'],
        'codeInstructions': json['codeInstructions'] == null ? undefined : json['codeInstructions'],
        'scanInstructions': json['scanInstructions'] == null ? undefined : json['scanInstructions'],
        'validQrPattern': json['validQrPattern'] == null ? undefined : json['validQrPattern'],
        'appliedFilterIds': json['appliedFilterIds'] == null ? undefined : json['appliedFilterIds'],
        'excludedGlobalFilters': json['excludedGlobalFilters'] == null ? undefined : ((json['excludedGlobalFilters'] as Array<any>).map(GlobalFilterExclusionInputFromJSON)),
        'failOpenOnMissingContext': json['failOpenOnMissingContext'] == null ? undefined : json['failOpenOnMissingContext'],
        'icon': json['icon'] == null ? undefined : json['icon'],
    };
}

export function QuestConfigMilestoneToJSON(json: any): QuestConfigMilestone {
    return QuestConfigMilestoneToJSONTyped(json, false);
}

export function QuestConfigMilestoneToJSONTyped(value?: QuestConfigMilestone | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'logicType': LogicModuleTypeToJSON(value['logicType']),
        'targetAmount': value['targetAmount'],
        'sessionAmount': value['sessionAmount'],
        'sessionCadence': QuestResetToJSON(value['sessionCadence']),
        'triggerEvent': EventValidatorToJSON(value['triggerEvent']),
        'resetEvent': EventValidatorToJSON(value['resetEvent']),
        'finishEvent': EventValidatorToJSON(value['finishEvent']),
        'sources': value['sources'] == null ? undefined : ((value['sources'] as Array<any>).map(DataSourceToJSON)),
        'id': value['id'],
        'earnConfigId': value['earnConfigId'],
        'socialPolicy': SocialPolicyToJSON(value['socialPolicy']),
        'rewardConfigIds': value['rewardConfigIds'],
        'rewardAutoSettings': value['rewardAutoSettings'],
        'rewardConfigs': value['rewardConfigs'] == null ? undefined : ((value['rewardConfigs'] as Array<any>).map(RewardConfigResponseToJSON)),
        'rewardGrants': value['rewardGrants'] == null ? undefined : ((value['rewardGrants'] as Array<any>).map(RewardGrantToJSON)),
        'name': value['name'],
        'description': value['description'],
        'gameId': value['gameId'],
        'progressionOrder': value['progressionOrder'],
        'displayDivider': value['displayDivider'],
        'rewardPer': value['rewardPer'],
        'checkpoints': value['checkpoints'] == null ? undefined : ((value['checkpoints'] as Array<any>).map(MilestoneCheckpointToJSON)),
        'url': value['url'],
        'subtype': MilestoneSubtypeToJSON(value['subtype']),
        'displayPriority': value['displayPriority'],
        'photoExampleAssetId': value['photoExampleAssetId'],
        'photoInstructions': value['photoInstructions'],
        'codeInstructions': value['codeInstructions'],
        'scanInstructions': value['scanInstructions'],
        'validQrPattern': value['validQrPattern'],
        'appliedFilterIds': value['appliedFilterIds'],
        'excludedGlobalFilters': value['excludedGlobalFilters'] == null ? undefined : ((value['excludedGlobalFilters'] as Array<any>).map(GlobalFilterExclusionInputToJSON)),
        'failOpenOnMissingContext': value['failOpenOnMissingContext'],
        'icon': value['icon'],
    };
}

